// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__1D_c1"};